import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { ConversationProgressStubStyled } from './styles/ConversationStreamStyled'

interface IConversationThinkingIndicatorProps {
  label?: Nullable<string>
}

export const ConversationThinkingIndicator = ({
  label = null,
}: IConversationThinkingIndicatorProps) => {
  const intl = useProcurifyIntl()

  return (
    <ConversationProgressStubStyled
      role='status'
      aria-label={intl.formatMessage(messages.typing)}
    >
      {label ?? intl.formatMessage(messages.thinkingDefault)}
    </ConversationProgressStubStyled>
  )
}
